import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CONSTANTS from '../../constants';
import ParamHelper from '../../helpers/ParamHelper';
import ViewHelper from '../../helpers/ViewHelper';
import CartService from '../../services/CartService';

class ViewCart extends Component {
  goToCart() {
    const connection = window.navigator.onLine;
    if (connection) {
      this.props.history.push(
        `${CONSTANTS.BASE_URL}${ParamHelper.getLocationId(this.props)}/confirm/`
      );
    } else {
      ViewHelper.showNetworkAlert(this.props._location.name);
    }
  }

  componentDidMount() {
    const items = CartService.getCart(this.props._location.loc_id);
    const discountedItems = items.map((i) => ({
      ...i,
      discounts: ViewHelper.getDiscountedItemPrice(
        i.menu_price,
        i.menu_id,
        i.menu_category_id,
        this.props.promotions,
        this.props.order_type_id,
        this.props.orderTypes
      )
    }));
    CartService.setCart(discountedItems);
  }
  componentDidUpdate(prevProps, nextProps) {
    if (prevProps !== this.props) {
      const items = CartService.getCart(this.props._location.loc_id);
      const discountedItems = items.map((i) => ({
        ...i,
        discounts: ViewHelper.getDiscountedItemPrice(
          i.menu_price,
          i.menu_id,
          i.menu_category_id,
          this.props.promotions,
          this.props.order_type_id,
          this.props.orderTypes
        )
      }));
      CartService.setCart(discountedItems);
    }
  }

  componentDidMount() {
    const items = CartService.getCart(this.props._location.loc_id);
    const discountedItems = items.map(i => ({
      ...i,
      discounts: ViewHelper.getDiscountedItemPrice(i.menu_price, i.menu_id, i.menu_category_id, this.props.promotions)
    }))
    CartService.setCart(discountedItems);
  }

  render() {
    let { _location, promotions } = this.props;
    let cart = CartService.getCart(_location.loc_id);
    let orderTotal = CartService.getOrderTotal(_location.loc_id, _location.tax_percent);
    let orderDiscount = CartService.getDiscount(_location, promotions, this.props.order_type_id);
    let afterDiscount = orderTotal - orderDiscount.discount;
    let margin = orderTotal !== afterDiscount ? 'margin-view-cart' : '';
    const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
    if (cart && cart.length > 0) {
      return (
        <div
          className={`view-cart enabled ${branding_btn} cursor shadow-lg`}
          onClick={this.goToCart.bind(this)}
        >
          <div className="count f3 branding-btn-font-color">
            {CartService.getCount(_location.loc_id)}{' '}
            {CartService.getCount(_location.loc_id) > 1 ? 'Items' : 'Item'}
          </div>
          <div class={`button f2 branding-btn-font-color text-bold ${margin}`}>{this.props.text}</div>
          <div className="total f3 branding-btn-font-color">
            {orderTotal === afterDiscount ? (
              ViewHelper.toCurrency(afterDiscount, _location.currency, _location.decimal_places)
            ) : (
              <>
                <span className="text-decoration-line-through font-color-white mr-2 form-control-sm font-weight-lighter">
                  {ViewHelper.toCurrency(orderTotal, _location.currency, _location.decimal_places)}
                </span>
                <span className="font-color-white">
                  {ViewHelper.toCurrency(
                    afterDiscount,
                    _location.currency,
                    _location.decimal_places
                  )}
                </span>
              </>
            )}
          </div>
        </div>
      );
    }
    return '';
  }
}

export default withRouter(ViewCart);
